<template>
  <div class="timeline-item pb-5">
    <div class="timeline-line"></div>
    <div class="flex-column timeline-icon">
      <span>
        {{ new Date(createdAt).getDate() }}
        {{ $t(getMonthName(new Date(createdAt).getMonth())).substring(0,3) }}
      </span>
      <span>{{ new Date(createdAt).getFullYear() }}</span>
    </div>
    <div class="timeline-content m-0">
      <Card>
        <template #cardHeader>
          <div class="card-header">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold">
                <i :class="type.icon" class="fs-3 me-2" :style="{ color: type.color }" />
                <span :style="{ color: type.color }"> {{ type.name }} </span> <span v-if="detail.title"> : {{ detail.title }} </span>
              </span>
              <span v-if="detail.dateTime" class="text-muted mt-1 fw-semibold fs-6 mt-2">
                <span v-if="detail.type">
                  {{ type.name == 'Email' ? filterEmail(detail.type)[locale]
                        : type.name == 'Appel' ? filterCall(detail.type)[locale]
                        : detail.type
                  }} :</span> {{ $t('label.theM') }}
                {{ $dateFormatter(detail.dateTime.split(' ')[0].split('-').reverse().join('-') + ' ' + detail.dateTime.split(' ')[1], locale, true, true) }} <span class="ms-3" v-if="detail.duration"> {{ $t('crm.label.duration') }}: {{ formatDuration(detail.duration) }}</span>
              </span>
              
            </h3>
            <div class="card-toolbar">
              <div class="d-flex my-3 ms-9">
                <a v-if="false" class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" :title="$t('crm.pipeline.activity.set_as_done')" >
                  <i style="color: #303D4E" class="las la-check fs-3"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></i>
                </a>
                <button v-if="$can(abilities.UPDATE_ACTIVITY)" :disabled="pipeline?.status == 'WON' || pipeline?.status == 'LOST' || pipeline.status == 'ARCHIVED'" @click.prevent="toggleActivityEditModal(id, type.type)" class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" :title="$t('crm.pipeline.activity.edit')" >
                  <i  style="color: #303D4E" class="las la-edit fs-2"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></i>
                </button>
                <button v-if="$can(abilities.DELETE_ACTIVITY)" :disabled="pipeline?.status == 'WON' || pipeline?.status == 'LOST' || pipeline.status == 'ARCHIVED'" @click.prevent="deleteActivity(id)" class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" :title="$t('crm.pipeline.activity.cancel')" >
                  <i style="color: #303D4E" class="las la-times fs-2"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></i>
                </button>
              </div>
            </div>
          </div>
        </template>
        <template #cardBody>
          <div>
            <p>{{ detail.note }}</p>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <ManyAvatar v-if="false" symbol-size="25px"/>
            <div v-if="files.length" class="ms-auto d-flex align-items-center fw-semibold">
              <button @click.prevent="downloadFiles(files)" class="btn btn-sm btn-light btn-color-muted btn-active-light-primary px-4 py-2">
                <i class="las la-file-download fs-2 me-1"></i>
                {{ files.length }} {{$t("crm.label.associatedFile")}}
              </button>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script setup>
import {defineProps, computed} from 'vue'
import Card from "@/Modules/CRM/components/Card";
import ManyAvatar from "@/components/ManyAvatar";
import {$dateFormatter} from "@/mixins/Helpers";
import {useLocales} from "@/composables/locales";
import i18n from "@/plugins/i18n";
import {useRoute} from "vue-router";
import { useStore } from "vuex"
import {useSwal} from "@/composables/useSwal";
import abilities from "@/composables/abilities";

const {showSwal} = useSwal()
const { locale } = useLocales()

const route = useRoute()
const store = useStore()
const emits = defineEmits(['toggleActivityEditModal'])
const props = defineProps({
  id: { type: String, required: true },
  detail: {
    type: Object,
    default: () => ({
      title: '',
      priority: '',
      dateTime: '',
      note: '',
      type: null
    })
  },
  files: { type: Array, default: () => ([]) },
  type: {
    type: Object,
    default: () => ({
      id: '',
      color: '',
      icon: 'fa fa-mail-bulk',
      name: '',
    })
  },
  createdAt: { type: String, default: "" },
  pipeline: Object
})

const callActivityTypeEnum = computed(() => store.getters['activity/callActivityTypeEnum'])
const emailActivityTypeEnum = computed(() => store.getters['activity/emailActivityTypeEnum'])

const formatDuration = (duration) => {
  const [hours, minutes] = duration.split(':').map(Number);
  let formattedDuration = '';

  if (hours > 0) {
    formattedDuration += `${hours} ${i18n.global.t('hour')}${hours > 1 ? 's' : ''}`;
  }

  if (minutes > 0) {
    if (hours > 0) {
      formattedDuration += ' ';
    }
    formattedDuration += `${minutes} ${i18n.global.t('minute')}${minutes > 1 ? 's' : ''}`;
  }

  return formattedDuration || '0 minute';
};
function getMonthName(monthNumber) {
  const monthNames = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
  ];
  return monthNames[monthNumber];
}


function toggleActivityEditModal(id, type) {
  emits('toggleActivityEditModal', id, type)
}

function downloadFiles(files) {
  files.forEach(file => {
    const link = document.createElement('a');
    link.href = file.file_url;
    link.download = file.file || 'download';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
}

function deleteActivity(id) {
  showSwal(
    i18n.global.t('crm.pipeline.activity.swal.delete_title'),
    i18n.global.t('crm.pipeline.activity.swal.delete_text')
  ).then( async (result) => {
    if (result.value) {
      try {
        store.dispatch('activity/deleteActivity', id)
            .then(res => {
              store.dispatch('activity/loadOpportunityActivities', route.params.id)
              window.toastr['success'](i18n.global.t("notification.opportunityActivity_deleted"))
            })
      }catch (e) {
      }
    }
  });
}

function filterCall(value){
  let call = callActivityTypeEnum.value.filter(type => type.value === value)
  return call[0]
}

function filterEmail(value){
  let mail = emailActivityTypeEnum.value.filter(type => type.value === value)
  return mail[0]
}

</script>

<style >

.timeline {
  --bs-timeline-icon-size: 60px;
  --bs-timeline-icon-space: 0.60rem
}

.timeline .timeline-item {
  position: relative;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: flex-start
}

.timeline .timeline-item:last-child .timeline-line {
  bottom: 100%
}

.timeline .timeline-line {
  display: block;
  content: " ";
  justify-content: center;
  position: absolute;
  z-index: 0;
  left: 0;
  top: var(--bs-timeline-icon-size);
  bottom: 0;
  transform: translate(50%);
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: var(--bs-gray-300);
  width: var(--bs-timeline-icon-size);
  margin-top: var(--bs-timeline-icon-space);
  margin-bottom: var(--bs-timeline-icon-space)
}

.timeline .timeline-icon {
  z-index: 1;
  flex-shrink: 0;
  margin-right: 1rem;
  width: var(--bs-timeline-icon-size);
  height: var(--bs-timeline-icon-size);
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--bs-gray-300);
  border-radius: 50%
}

.timeline .timeline-content {
  width: 100%;
  overflow: visible;
  margin-bottom: 1.5rem
}

.timeline.timeline-center .timeline-item {
  align-items: center
}

.timeline.timeline-center .timeline-item:first-child .timeline-line {
  top: 50%
}

.timeline.timeline-center .timeline-item:last-child .timeline-line {
  bottom: 50%
}

.timeline.timeline-border-dashed .timeline-line {
  border-left-style: dashed!important
}

.timeline.timeline-border-dashed .timeline-icon {
  border-style: dashed!important
}

.timeline-label {
  position: relative
}

.timeline-label:before {
  content: "";
  position: absolute;
  left: 51px;
  width: 3px;
  top: 0;
  bottom: 0;
  background-color: var(--bs-gray-200)
}

.timeline-label .timeline-item {
  display: flex;
  align-items: flex-start;
  position: relative;
  margin-bottom: 1.7rem
}

.timeline-label .timeline-item:last-child {
  margin-bottom: 0
}

.timeline-label .timeline-label {
  width: 50px;
  flex-shrink: 0;
  position: relative;
  color: var(--bs-gray-800)
}

.timeline-label .timeline-badge {
  flex-shrink: 0;
  background-color: var(--bs-body-bg);
  width: 1rem;
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: relative;
  margin-top: 1px;
  margin-left: -.5rem;
  padding: 3px!important;
  border: 6px solid var(--bs-body-bg)!important
}

.timeline-label .timeline-content {
  flex-grow: 1
}


</style>
